export default "__VITE_ASSET__CGykGty7__"